<template>
  <div>
    <!-- Header -->
    <div
      v-if="!cpid"
      class="m-1"
    >
      <b-row>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          lg="6"
        >
          <b-form-group
            :label="$t('common.full-text')"
            label-for="search"
          >
            <b-form-input
              v-model="filteringData.q"
              class="d-inline-block "
              :placeholder="$t('common.search')"
              @keydown.enter.native="startSearch()"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="6"
        >
          <b-form-group
            :label="$t('contributors.full-name')"
            label-for="full-name"
          >
            <b-form-input
              v-model="filteringData.fullName"
              class="d-inline-block "
              :placeholder="$t('contributors.full-name')"
              @keydown.enter.native="startSearch()"
            />
          </b-form-group>
        </b-col>

        <!-- Address Filter -->
        <b-col
          cols="12"
          md="6"
          lg="6"
        >
          <b-form-group
            :label="$t('contributors.email')"
            label-for="email"
          >
            <b-form-input
              v-model="filteringData.email"
              class="d-inline-block "
              :placeholder="$t('contributors.email')"
              @keydown.enter.native="startSearch()"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="4"
        >
          <b-form-group
            :label="$t('contributors.address-city')"
            label-for="city"
          >
            <b-form-input
              v-model="filteringData.addressCity"
              class="d-inline-block "
              :placeholder="$t('contributors.address-city')"
              @keydown.enter.native="startSearch()"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          lg="2"
        >
          <b-form-group
            :label="$t('contributors.address-kanton')"
            label-for="kanton-pv"
          >
            <v-select
              v-model="filteringData.addressKanton"
              :options="lookupOptions.kantonPVOptions"
              :reduce="val => val.value"
              input-id="kanton-pv"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <app-collapse class="w-100">
          <app-collapse-item title="#">
            <template #header>
              <span class="small font-weight-bold">{{ $t('donations.more-filters') }}</span>
            </template>
            <b-row>
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('contributors.filter-status-label')"
                  label-for="statusFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.status"
                      :options="lookupOptions.statusOptions"
                      class="w-100"
                      :placeholder="$t('contributors.filter-status')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('contributors.contributor-type')"
                  label-for="statusFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.contributorType"
                      :options="lookupOptions.contributorTypeOptions"
                      class="w-100"
                      :placeholder="$t('contributors.filter-contributor-type')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('contributors.filter-tags-label')"
                  label-for="tagsFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <tags-selector
                      v-model="filteringData.tags"
                      :invertable="true"
                      :tags-options="lookupOptions.tagsOptions"
                      :tags-colors="lookupOptions.tagsColors"
                    />
                  </div>
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <!-- From/To dates Filter -->
              <b-col
                cols="12"
                md="3"
              >
                <b-form-group
                  :label="$t('contributors.from-date')"
                  label-for="from-date"
                >
                  <date-picker-input
                    id="from-date"
                    v-model="filteringData.fromDate"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="3"
              >
                <b-form-group
                  :label="$t('contributors.to-date')"
                  label-for="to-date"
                >
                  <date-picker-input
                    id="to-date"
                    v-model="filteringData.toDate"
                  />
                </b-form-group>
              </b-col>
              <!-- annoAdesione From/To Filter -->
              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('contributors.from-annoAdesione')"
                  label-for="from-annoAdesione"
                >
                  <b-form-input
                    v-model="filteringData.annoAdesioneFrom"
                    :placeholder="$t('contributors.annoAdesione')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('contributors.to-annoAdesione')"
                  label-for="to-annoAdesione"
                >
                  <b-form-input
                    v-model="filteringData.annoAdesioneTo"
                    :placeholder="$t('contributors.annoAdesione')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- annoCancellazione From/To Filter -->
              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('contributors.from-annoCancellazione')"
                  label-for="from-annoCancellazione"
                >
                  <b-form-input
                    v-model="filteringData.annoCancellazioneFrom"
                    :placeholder="$t('contributors.annoCancellazione')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('contributors.to-annoCancellazione')"
                  label-for="to-annoCancellazione"
                >
                  <b-form-input
                    v-model="filteringData.annoCancellazioneTo"
                    :placeholder="$t('contributors.annoCancellazione')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

            </b-row>
          </app-collapse-item>
        </app-collapse>
      </b-row>

      <b-row>
        <b-button
          id="_buttonSearch"
          class="btn-block"
          variant="outline-primary"
          @click="startSearch()"
        >
          <span class="text-nowrap">{{ $t('common.search-button') }}</span>
        </b-button>
      </b-row>

    </div>
    <!-- Table -->
    <b-table
      id="_listTable"
      ref="refListTable"
      class="position-relative"
      :items="fetchItems"
      responsive
      striped
      :fields="tableColumns"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text=" $t('common.no-matching')"
      :sort-desc.sync="isSortDirDesc"
    >

      <!-- Column: User -->
      <template #cell(user)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              size="32"
              :src="data.item.avatar"
              :text="avatarText(data.item.fullName)"
              :variant="`light-${resolveAvatarVariant(data.item.fullName)}`"
              :disabled="data.item.isLinked"
              @click="goto(data.item)"
            />
          </template>
          <b-link
            class="font-weight-bold d-block text-nowrap"
            :disabled="data.item.isLinked"
            @click="goto(data.item)"
          >
            {{ data.item.fullName }}
            <span
              v-if="data.item.isLinked"
              class="text-success"
              :title="$t('donations.is-linked')"
            ><feather-icon
              icon="LinkIcon"
            /></span>
          </b-link>
          <small>{{ (data.item.contributorCode ? data.item.contributorCode + ' / ' : '') }}{{ data.item.address ? formatAddress(data.item.address, true) : '' }}</small>
        </b-media>
      </template>

      <!-- Column: Tags -->
      <template #cell(tags)="data">
        <span
          v-for="tag in new Set(data.item.tags)"
          :key="tag"
        >
          <b-badge
            v-b-tooltip.hover
            class="mr-25"
            :title="tag"
            :style="{ 'background-color': resolveTagBackground(tag, lookupOptions.tagsColors) }"
            pill
          >&nbsp;<feather-icon
            v-if="resolveTagIcon(tag) !== null"
            :icon="resolveTagIcon(tag)"
          />&nbsp;
          </b-badge>
        </span>
      </template>

      <!-- Column: Donations -->
      <template #cell(donations)="data">
        <span
          v-for="(donats, index) in data.item.donations"
          :key="index"
        >
          <small class="clearfix">{{ (donats.donations_amount ? `${formatCurrency(donats.donations_amount, donats.currency)}${donats.donations_distinct > 0 ? ` - ${donats.donations_distinct} SAD/prog.` : ''}` : '-') }}</small>
        </span>
      </template>

      <!-- Column: Status -->
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="`light-${resolveStatusVariant(data.item.status)}`"
          class="text-capitalize"
        >
          {{ data.item.status }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-link
          v-if="!data.item.isLinked"
          v-b-tooltip.hover
          :title="$t('donations.add-new')"
          class="text-nowrap ml-1"
          :to="{ name: 'view-contributors', query: { newDonation: true }, params: { id: data.item.cid } }"
        >
          <feather-icon
            icon="DollarSignIcon"
            class="cursor-pointer"
            size="16"
          />
        </b-link>
      </template>
    </b-table>

    <table-paginator
      v-model="currentPage"
      :total-items="totalItems"
      :per-page="perPage"
      :local-items-count=" (refListTable && refListTable.localItems ? refListTable.localItems.length : 0) "
    />

    <exporter-modal ref="modalExporter" />
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import {
  BRow, BCol, BFormInput, BTable, BMedia, BAvatar, BLink, BBadge, VBTooltip, BFormGroup, BButton,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import axios from '@axios'
import vSelect from 'vue-select'
import { ref, watch } from '@vue/composition-api'
import authService from '@/vue.auth.service'
import lookupsService from '@/vue.lookups.service'
import sessionService from '@/vue.session.service'
import i18n from '@/libs/i18n'
import TablePaginator from '../layouts/tables/TablePaginator.vue'
import TagsSelector from '../layouts/tables/TagsSelector.vue'
import ExporterModal from '../layouts/ExporterModal.vue'
import DatePickerInput from '../layouts/DatePickerInput.vue'

import {
  resolveStatusVariant, avatarText, resolveAvatarVariant, formatDateHumanFriendly, formatAddress, formatCurrency,
  resolveTagBackground, resolveTagIcon, download, throwError, scrollTo, isValidYear,
} from '../layouts/layouts.utils'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    vSelect,
    BFormGroup,
    TablePaginator,
    TagsSelector,
    ExporterModal,
    BButton,
    AppCollapse,
    AppCollapseItem,
    DatePickerInput,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    callback: {
      default: null,
    },
    cpid: {
      required: false,
      default: null,
    },
    isLinked: {
      required: false,
      default: null,
    },
    linkedArea: {
      required: false,
      default: null,
    },
  },
  computed: {
    // eslint-disable-next-line no-nested-ternary
    tableColumns() {
      // Table Handlers
    /* eslint-disable object-curly-newline */
      const columns = [
        { key: 'user', label: i18n.t('contributors.full-name-full'), sortable: true, sortKey: 'fullName' },
        { key: 'contacts', label: i18n.t('contributors.contacts'), tdClass: 'small', formatter: (value, key, item) => `${item.email ? item.email : ''}${item.contact ? (item.email ? ' - ' : '') + item.contact : ''}` },
        { key: 'tags', label: i18n.t('contributors.filter-tags-label') },
        { key: 'status', label: i18n.t('contributors.filter-status-label') },
        { key: 'lastDonation', label: i18n.t('contributors.last-donations'), sortable: true, formatter: formatDateHumanFriendly },
        { key: 'donations', label: i18n.t('contributors.donations') },
        { key: 'lastUpdate', label: i18n.t('common.last-update-short'), sortable: true, formatter: formatDateHumanFriendly },
      ]
      if (authService.isUserInRole('write') && !this.modal && !this.cpid) { columns.push({ key: 'actions', label: i18n.t('common.actions') }) }

      return columns
    },
  },
  async mounted() {
    await this.reload()
    // eslint-disable-next-line no-underscore-dangle
    if (!this._events.changedArea) {
      this.$root.$on('changedArea', () => {
        this.reload()
      })
    }

    this.$watch('linkedArea', () => {
      this.refresh()
    }, { immediate: true })
  },
  beforeDestroy() {
    this.$root.$off('changedArea')
  },
  methods: {
    async reload() {
      const currentArea = await authService.currentArea()
      if (currentArea !== null) {
        this.reloadArea(currentArea)
      }
    },
    async reloadArea(area) {
      this.refaid = null
      const { obsoletes } = area.settings
      const options = {
        statusOptions: await lookupsService.getMaps('contributors.status', area.aid, obsoletes),
        tagsOptions: await lookupsService.getMaps('contributors.tags', area.aid, obsoletes),
        tagsColors: area.settings.tags,
        kantonPVOptions: (area.settings.defaults.state === 'CH' ? lookupsService.getKantonOptions() : lookupsService.getProvinceOptions()),
        contributorTypeOptions: await lookupsService.getMaps('contributors.contributorType', area.aid),
      }
      this.lookupOptions = options
      this.refaid = area.aid
      if (!this.cpid) {
        const filters = sessionService.getValue(`contributors.filters.${this.refaid}`)
        if (filters && filters !== null) { this.setFilters(filters) } else this.setFilters(null)
      }
      this.refetchData()
    },
    goto(item) {
      if (this.modal) {
        if (this.callback) this.callback(item)
      } else this.$router.push({ name: 'view-contributors', params: { id: item.cid } })
    },
    expoort() {
      this.$refs.modalExporter.show('contributors', (columns, exporterName) => {
        const filters = this.fetchFilters()
        filters.columns = columns
        axios.post('/api/exports/contributors', filters, { responseType: 'arraybuffer' })
          .then(response => {
            download(response, exporterName)
            this.$refs.modalExporter.cancel()
          })
          .catch(error => {
            throwError(error)
            this.$refs.modalExporter.cancel()
          })
      })
    },
    refresh() {
      this.refetchData()
    },
    clearFilters() {
      if (!this.cpid) sessionService.remove(`contributors.filters.${this.refaid}`)
      this.reload()
    },
    startSearch() {
      this.refetchData(true)
      scrollTo('_buttonSearch')
    },
  },
  setup(props) {
    const refaid = ref(null)
    const refListTable = ref(null)
    const perPage = ref(15)
    const totalItems = ref(0)
    const currentPage = ref(1)
    const sortBy = ref(null)
    const isSortDirDesc = ref(false)
    const filteringData = ref({})
    const lookupOptions = ref([])
    const isReloading = ref(false)

    function fetchFilters() {
      const filter = {
        aid: refaid.value,
        params: {
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value ? sortBy.value : 'fullName',
          sortDesc: sortBy.value ? isSortDirDesc.value : false },
        filters: filteringData.value,
      }
      if (props.cpid) filter.filters.cpid = props.cpid
      if (props.cpid && props.isLinked && props.linkedArea) filter.filters.linkedArea = props.linkedArea
      return filter
    }
    function setFilters(filters) {
      isReloading.value = true
      filteringData.value = (filters ? filters.filters : { })
      sortBy.value = (filters ? filters.params.sortBy : null)
      isSortDirDesc.value = (filters ? filters.params.sortDesc : false)
      perPage.value = (filters ? filters.params.perPage : 15)
      currentPage.value = (filters ? filters.params.page : 1)
    }

    const refetchData = async resetPaging => {
      if (refaid.value !== null) {
        const filter = fetchFilters()
        if (resetPaging) {
          isReloading.value = true
          currentPage.value = 1
        }
        if (filter && ((filter.filters.annoAdesioneFrom && !isValidYear(filter.filters.annoAdesioneFrom))
         || (filter.filters.annoAdesioneTo && !isValidYear(filter.filters.annoAdesioneTo))
         || (filter.filters.annoCancellazioneFrom && !isValidYear(filter.filters.annoCancellazioneFrom))
         || (filter.filters.annoCancellazioneTo && !isValidYear(filter.filters.annoCancellazioneTo))
        )) { return }
        await refListTable.value.refresh()
        isReloading.value = false
      }
    }
    watch([currentPage, perPage], () => {
      if (!isReloading.value) refetchData()
    })

    function fetchItems(ctx, callback) {
      if (refaid.value == null) {
        totalItems.value = 0
        callback([])
      } else {
        const filters = fetchFilters()
        if (!props.cpid) sessionService.setValue(`contributors.filters.${filters.aid}`, filters)
        axios.post('/api/lists/contributors', filters)
          .then(response => {
            const { items, total } = response.data
            callback(items)
            totalItems.value = total
          })
          .catch(error => { throwError(error); callback([]) })
      }
    }

    return {
      refaid,
      fetchItems,
      fetchFilters,
      setFilters,
      perPage,
      currentPage,
      totalItems,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      avatarText,
      formatAddress,
      formatCurrency,
      resolveAvatarVariant,
      resolveStatusVariant,
      resolveTagBackground,
      resolveTagIcon,
      lookupOptions,
      filteringData,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
